import React from 'react';
import View from '@src/components/view';
import lockAsync from '@src/utils/lock-async';
import { withoutProps } from '@src/utils/data-utils';

const styles = require('./index.less');

/**
 * 路由异常组件
 */
export default class RouteError extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  /**
   * 防止快速多次点击, 确保点击后 500 毫秒内 lock 住
   * @param {Event} e
   */
  @lockAsync(undefined, { minLockTime: 500 })
  onClick(e) {
    this.props.onClick(e);
  }

  render() {
    const { ...restProps } = withoutProps(this.props, ['onClick']);
    return (
      <View css={styles.root} onClick={this.onClick} {...restProps}>
        网络异常/(ToT)/~~
      </View>
    );
  }
}
